import React from 'react';

const Catalog = () => {
    return (
        <div>
            <h1>Catalog</h1>
            <p>Welcome to the catalog page.</p>
        </div>
    );
};

export default Catalog;